import React from "react";
import "./_lecturerTimeTableShimmer.scss";

// Base shimmer block — a single animated placeholder.
// Reused to compose the skeletons below so the sweep animation is identical everywhere.
export const Shimmer = ({ width = "100%", height = 16, radius = 8, style = {} }) => (
    <span className="ltt-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// One body row of the grid-table skeleton (date cell + period cells).
const TableRowShimmer = ({ cols }) => (
    <div style={{ display: "flex", gap: 14, padding: "14px 16px", borderBottom: "1px solid #eef2f7", alignItems: "flex-start" }}>
        <div style={{ flex: "0 0 150px" }}>
            <Shimmer width="65%" height={12} style={{ marginBottom: 8 }} />
            <Shimmer width={80} height={16} radius={20} />
        </div>
        {Array.from({ length: cols }).map((_, i) => (
            <div key={i} style={{ flex: 1 }}>
                <Shimmer width="80%" height={12} style={{ marginBottom: 7 }} />
                <Shimmer width="55%" height={9} style={{ marginBottom: 6 }} />
                <Shimmer width="40%" height={9} />
            </div>
        ))}
    </div>
);

// Tab strip + grid-table skeleton — shown while the timetable query is loading.
export const LecturerTimeTableShimmer = ({ rows = 5, cols = 5 }) => (
    <div>
        {/* Tab strip */}
        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", borderRadius: "12px 12px 0 0", padding: "12px 12px 0", display: "flex", gap: 8 }}>
            {[120, 110, 110].map((w, i) => <Shimmer key={i} width={w} height={34} radius={8} />)}
        </div>
        {/* Table card */}
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderTop: "none", borderRadius: "0 0 12px 12px", overflow: "hidden" }}>
            {/* Header row */}
            <div style={{ display: "flex", gap: 14, padding: "14px 16px", background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                <div style={{ flex: "0 0 150px" }}><Shimmer width={60} height={12} /></div>
                {Array.from({ length: cols }).map((_, i) => (
                    <div key={i} style={{ flex: 1 }}><Shimmer width="55%" height={12} /></div>
                ))}
            </div>
            {Array.from({ length: rows }).map((_, r) => <TableRowShimmer key={r} cols={cols} />)}
        </div>
    </div>
);

// Full-page skeleton for the initial globals load (header bar + filter panel + table).
export const LecturerTimeTablePageShimmer = () => (
    <section style={{ padding: "24px 28px", minHeight: "100vh", background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)" }}>
        {/* Header bar */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, padding: "18px 22px", background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0", marginBottom: 18 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <Shimmer width={46} height={46} radius={12} />
                <div>
                    <Shimmer width={190} height={16} style={{ marginBottom: 8 }} />
                    <Shimmer width={240} height={10} />
                </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
                <Shimmer width={150} height={36} radius={9} />
                <Shimmer width={170} height={36} radius={9} />
            </div>
        </div>

        {/* Filter panel */}
        <div style={{ background: "#f8fafc", borderRadius: 16, border: "1.5px solid #e2e8f0", padding: "20px 24px", marginBottom: 22, display: "flex", gap: 16, flexWrap: "wrap" }}>
            {[0, 1, 2, 3, 4, 5].map((i) => (
                <div key={i} style={{ flex: "1 1 150px" }}>
                    <Shimmer width="45%" height={10} style={{ marginBottom: 8 }} />
                    <Shimmer width="100%" height={38} radius={9} />
                </div>
            ))}
        </div>

        {/* Tabs + table */}
        <LecturerTimeTableShimmer rows={5} cols={5} />
    </section>
);
